type MeetingGoalsVisibilityParams = {
	currentUserId: string;
	meetingParticipantIds: string[];
	isAdmin: boolean;
	directReportIds: string[];
	contributesToIds: string[];
	descendantIds: string[];
};

export const getVisibleGoalAssigneeIds = ({
	currentUserId,
	meetingParticipantIds,
	isAdmin,
	directReportIds,
	contributesToIds,
	descendantIds,
}: MeetingGoalsVisibilityParams): string[] => {
	const participantIds = meetingParticipantIds.filter(Boolean);
	const visibleIds = new Set<string>();

	if (currentUserId) {
		visibleIds.add(currentUserId);
	}

	if (isAdmin) {
		participantIds.forEach((participantId) => {
			visibleIds.add(participantId);
		});
		return Array.from(visibleIds);
	}

	const directReports = new Set(directReportIds);
	const contributesTo = new Set(contributesToIds);
	const descendants = new Set(descendantIds);

	participantIds.forEach((participantId) => {
		if (participantId === currentUserId) {
			return;
		}

		if (contributesTo.has(participantId) || directReports.has(participantId) || descendants.has(participantId)) {
			visibleIds.add(participantId);
		}
	});

	return Array.from(visibleIds);
};
